module.exports = __webpack_public_path__ + "img/rivet_jyo2g6.ce547c50.svg";